import { reactive } from 'vue';
import { FormInstance } from '../schemas';
import debug from 'debug';

const log = debug('itp:core:useForms');

export function useForms(friendlyName: () => string) {
  const forms = reactive<Record<string, FormInstance | null>>({});

  const registerForm = (name: string, form: FormInstance) => {
    forms[name] = form;
    log('[%s] register form %s', friendlyName(), name);
  };

  const unregisterForm = (form: FormInstance) => {
    if (forms[form.name]) {
      forms[form.name] = null;
      log('[%s] unregister form %s', friendlyName(), form.name);
    }
  };

  return {
    forms,
    registerForm,
    unregisterForm,
  };
}
